import React, { useState, useEffect } from "react";
import Layout from "../components/ui/Layout";
import { Link } from "react-router-dom";
import ProgressBar from "../components/ui/ProgressBar";
import { ArrowRight, Minus, Plus } from "lucide-react";

const ModelReno = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [zoomedImage, setZoomedImage] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleZoom = (image) => {
    setZoomedImage(zoomedImage === image ? null : image);
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
    
    // If opening a new panel, scroll to the top of it
    if (expandedIndex !== index) {
      // Wait for the next tick to ensure the panel is rendered
      setTimeout(() => {
        const element = document.getElementById(`accordion-${index}`);
        if (element) {
          // Get the header height (adjust this value based on your header height)
          const headerHeight = 80; // Adjust this value based on your header height
          
          // Calculate the position to scroll to
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
          
          // Smooth scroll to the element
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100); // Small delay to ensure the panel is rendered
    }
  };

  // Disable scrolling when zoomed
  useEffect(() => {
    if (zoomedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [zoomedImage]);

  return (
    <Layout>
      {/* Zoom Modal */}
      {zoomedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          onClick={() => setZoomedImage(null)}
        >
          <img
            src={zoomedImage}
            alt="Zoomed view"
            className="max-w-[90%] max-h-[90vh] object-contain"
          />
        </div>
      )}

      <ProgressBar />

      {/* Hero Section */}
      <section id="model-reno" className="text-black py-8">
        <div className="container mx-auto px-8 flex flex-col md:flex-row items-center gap-8">
          <div className="md:w-2/3 text-left flex justify-start items-center">
            <h1 className="text-5xl md:text-7xl leading-tight w-full self-start font-thin">
              Standing Out in a Crowded Market: Building Trust Through Ethical UX in Renovation Services
            </h1>
          </div>
          <div className="md:w-1/3 flex justify-center">
            <img
              src="https://res.cloudinary.com/dlzvz9qj8/image/upload/v1741595069/Partnership_in_security_and_safeguarding_a7t6qv.png"
              alt="Renovation UX Case Study"
              className="w-full max-w-sm h-auto cursor-zoom-in"
              onClick={() => toggleZoom("https://res.cloudinary.com/dlzvz9qj8/image/upload/v1741595069/Partnership_in_security_and_safeguarding_a7t6qv.png")}
            />
          </div>
        </div>
      </section>


      {/* Mockup Images Section */}
      <section className="py-4">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 max-w-4xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex justify-center">
              <img
                src="https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744255369/Home_gj0ybg.png"
                alt="iPhone Mockup 1"
                className="max-w-[280px] h-auto cursor-zoom-in"
                onClick={() => toggleZoom("https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744255369/Home_gj0ybg.png")}
              />
            </div>
            <div className="flex justify-center">
              <img
                src="https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744255344/Sign_up_inkjgn.png"
                alt="iPhone Mockup 2"
                className="max-w-[280px] h-auto cursor-zoom-in"
                onClick={() => toggleZoom("https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744255344/Sign_up_inkjgn.png")}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="py-8">
          <div className="mt-8 max-w-3xl mx-auto">
            <p>The customers for renovations service today is skeptical. They've seen indecent break-ups in various ways with renovation companies and would not want to be one of them. They look into multiple websites that looks same - promising, but not trustable.<br></br>Model Reno came to me for UX consultation for their website. And I don't feel I trust them either by looking at the website- trying to collect my personal data, forcing me to sign up, looks too elegant to be true...  This is where ethical UX kicks in to build trust.</p>
          </div>
      </section>


      {/* Understanding the Company Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8 text-center">Step 1: Understanding the Company</h2>
          <div className="space-y-8">
            <div>
              <h3 className="font-bold mb-4">About the Company</h3>
              <p className="max-w-3xl">
                Model Reno is an end-to-end service provider that focuses on delivering a world-class bathroom renovation experience through top-quality designs, materials, and contractors.
              </p>
            </div>
            <div>
              <h3 className="font-bold mb-4">The Problem</h3>
              <p className="mb-4 max-w-3xl">Their official website has an average of 1.8K viewers, 95% of which are first-time browsers. However, the average engagement time on the website has decreased in the last three months and the information users leave on the website are fake at a high rate and users are usually unclear about the service Model Reno provides on the first-time phone call.</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="p-6 border flex flex-col items-center text-center">
                  <span className="text-4xl mb-4">📊</span>
                  <p>high rate of fake personal information</p>
                </div>
                <div className="p-6 border flex flex-col items-center text-center">
                  <span className="text-4xl mb-4">⏱️</span>
                  <p>low engagement time</p>
                </div>
                <div className="p-6 border flex flex-col items-center text-center">
                  <span className="text-4xl mb-4">❓❓</span>
                  <p>unclear company service information</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Research Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8 text-center">Step 2: Understand Users</h2>
          
          {/* Website Analytics */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">Analyze Website Data</h3>
            <p className="mb-4">(Sidenote: Due to privacy reasons and Non-disclosure Agreement, detailed data and part of the business information are not shown in this case study.)</p>
            <p className="mb-6">I accessed Google Analytics to understand website browsers' sources and behaviors. Specifically, I fetched information about user demographic, device preference, user traffic and page engagement time.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_e785a9a9d83b4dcab66f9e6abbee3c32~mv2.png/v1/crop/x_438,y_316,w_358,h_428/fill/w_501,h_599,al_c,lg_1,q_85,enc_auto/%E5%9B%BE%E7%89%871.png"
                  alt="Website Analytics Data 1"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_e785a9a9d83b4dcab66f9e6abbee3c32~mv2.png/v1/crop/x_438,y_316,w_358,h_428/fill/w_501,h_599,al_c,lg_1,q_85,enc_auto/%E5%9B%BE%E7%89%871.png")}
                />
              </div>
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_7ab9f5456acd456b89ee63f9f789a892~mv2.png/v1/crop/x_1440,y_275,w_381,h_495/fill/w_457,h_594,al_c,lg_1,q_85,enc_auto/cc7e8a_7ab9f5456acd456b89ee63f9f789a892~mv2.png"
                  alt="Website Analytics Data 2"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_7ab9f5456acd456b89ee63f9f789a892~mv2.png/v1/crop/x_1440,y_275,w_381,h_495/fill/w_457,h_594,al_c,lg_1,q_85,enc_auto/cc7e8a_7ab9f5456acd456b89ee63f9f789a892~mv2.png")}
                />
              </div>
            </div>

            <h4 className="text-lg font-semibold mb-4">Main Takeaways</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Users mainly comes from social media, Ads and self-initiated search.</li>
              <li>The majority of users access the website through mobile device.</li>
              <li>The most popular page on the website is an article indicating the cost of renovation in Canada.</li>
              <li>Users barely use the call-to-action button "Get a Quote".</li>
              <li>A fair share of users are attracted to the website through the "Design Studio" button.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Discovery Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8">Research</h2>
          
          {/* User Research */}
          <div className="space-y-8">
            <p>
I did competitor research according to the information given by the company, then I conducted secondary research and five interviews to understand people's thoughts and feelings in looking for bathroom renovation service. From all information gained, I created a persona about one of my interviewees, Spencer, because he represents a subset of bathroom renovation service seekers who focused on the efficiency and trustworthiness of the service. </p>
<div className="flex justify-center items-center">
  <p className="max-w-3xl text-left text-2xl">"Why does all bathroom service website look the same? Ask me for personal information, claim providing best service and limited information. I feel hard to trust any of them at the very beginning."</p> </div>

            <div>
              <div className="flex justify-center mb-8">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_865d7555c9fd4d5ea723dc4ed23f86bf~mv2.png/v1/fill/w_1131,h_900,al_c,q_90,enc_avif,quality_auto/Frame%202.png"
                  alt="User Persona"
                  className="max-w-[800px] h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_865d7555c9fd4d5ea723dc4ed23f86bf~mv2.png/v1/fill/w_1131,h_900,al_c,q_90,enc_avif,quality_auto/Frame%202.png")}
                />
              </div>
            </div>

      {/* Define Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8 text-center">Step 3: Define</h2>
          
          {/* Pain Points and Goals */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="p-6 border bg-white">
              <h3 className="font-bold mb-4">Business Goals</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Increased engagement time</li>
                <li>Low rate of fake personal information</li>
                <li>Clear company service information communicated</li>
              </ul>
            </div>
            <div className="p-6 border bg-white">
              <h3 className="font-bold mb-4">User Goals</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Find a trustworthy renovation team and the end result delivering added value to the house</li>
                <li>Easy to find key information on the website</li>
                <li>Feel safe and trustful when browsing a website</li>
              </ul>
            </div>
          </div>


      {/* Goal Relationships Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <div className="max-w-3xl mx-auto">
            <p className="mb-6">So far I have understand the company's business goals and users' goals. I proceeded to look at the relations between them and worked out a product requirement. The relations are very clear now:</p>
            
            <div className="space-y-4 text-2xl">
              <p> If users feel safe and trustful when browsing a website, there will a lower rate of fake personal information.</p>
              
              <p> If the company provides clearer information on the website, users will be easier to find key information.</p>
              
              <p>The engagement time showcases the users' experience in browsing the website and interest level of the companies service, which contributes to the final decision in finding a trustful renovation team.</p>
            </div>
          </div>
        </div>
      </section>
          {/* Product Requirements */}
          <div className="my-12">
            <h3 className="text-xl font-semibold mb-4">Product Requirements</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-6 border bg-white">
                <h4 className="font-bold mb-3">Be Reliable</h4>
                <ul className="list-disc list-inside space-y-2">
                  <li>Provide reliable information on the website</li>
                  <li>Provide safe experience in browsing the website</li>
                </ul>
              </div>
              <div className="p-6 border bg-white">
                <h4 className="font-bold mb-3">Be Engageable</h4>
                <ul className="list-disc list-inside space-y-2">
                  <li>Provide an engaging experience through interactions</li>
                </ul>
              </div>
              <div className="p-6 border bg-white">
                <h4 className="font-bold mb-3">Be Informative</h4>
                <ul className="list-disc list-inside space-y-2">
                  <li>Be informative of the company service, service process and end results</li>
                  <li>Be informative of the company's strengths</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Success Metrics */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Success Metrics</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-6 border bg-white flex flex-col items-center text-center">
                <p className="text-4xl font-bold text-primary">↑</p>
                <p className="mt-2">Increased Engagement Time</p>
              </div>
              <div className="p-6 border bg-white flex flex-col items-center text-center">
                <p className="text-4xl font-bold text-primary">↓</p>
                <p className="mt-2">Lower Fake Information Ratio</p>
              </div>
              <div className="p-6 border bg-white flex flex-col items-center text-center">
                <p className="text-4xl font-bold text-primary">✓</p>
                <p className="mt-2">Better Knowledge about Company Service</p>
              </div>
            </div>
          </div>
        </div>
      </section>

            <div>
              <h3 className="font-bold mb-4 text-2xl text-center">Step 4: Evaluate</h3>
              
              {/* Heuristic Evaluation Section */}
              <div className="mb-12">
                <h4 className="text-xl font-semibold mb-4">Heuristic Evaluation</h4>
                <p className="mb-6">The next step I took is to see how the users' needs are addressed by the current website. Most importantly, I wonder how users feel about the company's websites and what frustrations they have during the navigation. Therefore I did a heuristic evaluation for:</p>
                
                <div className="space-y-4 mb-6">
                  <p><span className="font-semibold">Target 1:</span> overall website performance</p>
                  <p><span className="font-semibold">Target 2:</span> key CTA flow- Get an Estimate</p>
                </div>

                <p className="mb-4">There are 6 rules being violated and 13 violation items in total and I rated their priority according to severity ratings:</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                  <div className="p-6 border bg-white">
                    <h5 className="font-semibold mb-4">Severity Ratings</h5>
                    <ul className="list-disc list-inside space-y-2">
                      <li>I don't agree that this is a usability problem at all</li>
                      <li>Cosmetic problem only: fix if time is available</li>
                      <li>Minor usability problem: fixing this should be given low priority</li>
                      <li>Major usability problem: important to fix, given high priority</li>
                      <li>Usability catastrophe: fix this before product can be released</li>
                    </ul>
                  </div>
                  <div className="p-6 border bg-white">
                    <h5 className="font-semibold mb-4">Findings</h5>
                    <p>5 high-priority violation items are found:</p>
                    <div className="flex justify-center mt-4">
                      <img
                        src="https://static.wixstatic.com/media/cc7e8a_00cf71111f0e4756b736dffa1a04a937~mv2.png/v1/fill/w_1144,h_407,al_c,q_90,enc_avif,quality_auto/Frame%208%20(1).png"
                        alt="Heuristic Evaluation"
                        className="max-w-full h-auto cursor-zoom-in"
                        onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_00cf71111f0e4756b736dffa1a04a937~mv2.png/v1/crop/x_0,y_139,w_4686,h_1742/fill/w_1960,h_728,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Frame%2021.png")}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Usability Test Section */}
              <div className="mb-12">
                <h4 className="text-xl font-semibold mb-4">Usability Test</h4>
                <p className="mb-6">I also reached out to 10 real users for a usability test and collected the following feedback.</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                  <div className="p-6 border bg-white">
                    <h5 className="font-semibold mb-4">Target 1: Website Overall Usability Interview</h5>
                    <h6 className="font-medium mb-2">Feedback</h6>
                    <ul className="list-disc list-inside space-y-2">
                      <li><span className="font-medium">Service range:</span> unsure about the service range at the first glance</li>
                      <li><span className="font-medium">Appointment:</span> unable to make an appointment because no availability is shown</li>
                      <li><span className="font-medium">Feeling unsafe:</span> feel uneasy to give real personal information</li>
                      <li><span className="font-medium">Portfolios:</span>
                        <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                          <li>no timeline</li>
                          <li>cannot be found until scrolling down</li>
                          <li>hidden before and after contrast</li>
                          <li>only 8 case studies which cannot show in list form</li>
                          <li>cannot know the differences between them before clicking everyone</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div className="p-6 border bg-white">
                    <h5 className="font-semibold mb-4">Target 2: CTA flow-Get an Estimate</h5>
                    <div className="flex justify-center">
                      <img
                        src="https://static.wixstatic.com/media/cc7e8a_c1421684a04a41e9932c07d06c9b26bd~mv2.png/v1/crop/x_75,y_14,w_1584,h_1424/fill/w_1584,h_1424,al_c,q_95,enc_auto/image%2024.png"
                        alt="Usability Test Target 1"
                        className="max-w-full h-auto cursor-zoom-in"
                        onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_c1421684a04a41e9932c07d06c9b26bd~mv2.png/v1/crop/x_75,y_14,w_1584,h_1424/fill/w_1584,h_1424,al_c,q_95,enc_auto/image%2024.png")}
                      />
                    </div>
                  </div>
                </div>

                <div className="p-6 border bg-white">
                  <h5 className="font-semibold mb-4">Evaluation Summary</h5>
                  <div className="flex flex-col md:flex-row items-center gap-6 mb-6">
                    <div className="flex justify-center">
                      <img
                        src="https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744258729/Screenshot_2025-04-09_at_9.18.43_PM_ftlinm.png"
                        alt="Evaluation Summary Visual"
                        className="max-w-[400px] h-auto cursor-zoom-in"
                        onClick={() => toggleZoom("https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744258729/Screenshot_2025-04-09_at_9.18.43_PM_ftlinm.png")}
                      />
                    </div>
                    <p>According to the heuristic evaluation and usability test, the current website has strengths in beautiful design and professionalism presence. It also features interactions for users to design their own studio and get a quote. However, there are also frustrations as shown in the report which weaken the reliability, engagement and informativeness. Therefore, the redesign should fix existing frustrations and fulfill these unsatisfied needs to make it more reliable, more engageable and more informative (product goal).</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Prioritization Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8 text-center">Step 5: Prioritization</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="p-6 border bg-white">
              <h3 className="font-bold mb-4">High Priority</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Homepage Consultation CTA</li>
                <li>Progress Visibility</li>
                <li>Transparent Information Collection</li>
                <li>Early Service Information</li>
                <li>Enhanced Navigation</li>
              </ul>
            </div>
            <div className="p-6 border bg-white">
              <h3 className="font-bold mb-4">Medium Priority</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Saved Notification</li>
                <li>Persistent Progress Indicator</li>
              </ul>
            </div>
            <div className="p-6 border bg-white">
              <h3 className="font-bold mb-4">Low Priority</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Visual Design Updates</li>
                <li>Content Optimization</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Design Solutions Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8 text-center">Step 6: Design Decisions</h2>
          
          {/* Solution 1: Homepage Consultation CTA */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">1. Homepage Consultation CTA</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_9d5296d49d0944d984f876f29f26cddf~mv2.png/v1/crop/x_43,y_93,w_1067,h_1048/fill/w_1064,h_1048,al_c,q_90,enc_avif,quality_auto/cc7e8a_9d5296d49d0944d984f876f29f26cddf~mv2.png"
                  alt="Homepage Consultation CTA"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_9d5296d49d0944d984f876f29f26cddf~mv2.png/v1/crop/x_43,y_93,w_1067,h_1048/fill/w_1064,h_1048,al_c,q_90,enc_avif,quality_auto/cc7e8a_9d5296d49d0944d984f876f29f26cddf~mv2.png")}
                />
              </div>
              <div>
                <p className="mb-4">Make consultation entry another CTA button and appear on the homepage.</p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Tackled Frustrations: No show of consultation appointment on the website and no availability shown if clicked.</li>
                  <li>Related Pain Points: User lack of trust in the company, Company low engagement time</li>
                  <li>Why Urgent: Directly related to active potential customers seeking renovation service consultation</li>
                  <li>How it works: Users can now easily find the consultation option on the homepage and be subtly reminded to consult the company service. The tech team ensures availability is updated via Calendly.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Solution 2: Progress Visibility */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">2. Progress Visibility</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_e3c867d9cef74722ad7cf88db720efd5~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_e3c867d9cef74722ad7cf88db720efd5~mv2.png"
                  alt="Progress Visibility"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_e3c867d9cef74722ad7cf88db720efd5~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_e3c867d9cef74722ad7cf88db720efd5~mv2.png")}
                />
              </div>
              <div>
                <ul className="list-disc list-inside space-y-2">
                  <li>Frustrations: Violation of Heuristic Principles. Visibility of System Status</li>
                  <li>Related Pain Points: User lack of trust in the company, Company low engagement time</li>
                  <li>Why Urgent: This is in the main CTA flow. Get a Quote. If not fixed, users might quit early and it could decay trust in the company.</li>
                  <li>How it works: The progress bar indicates all steps with conversational prompts and helps users stay oriented through the flow.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Solution 3: Transparent Information Collection */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">3. Transparent Information Collection</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_aacefddb017245cd97e5098acf469915~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_aacefddb017245cd97e5098acf469915~mv2.png"
                  alt="Transparent Information Collection"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_aacefddb017245cd97e5098acf469915~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_aacefddb017245cd97e5098acf469915~mv2.png")}
                />
              </div>
              <div>
                <ul className="list-disc list-inside space-y-2">
                  <li>Frustrations: Pop-up forms in the middle of key flow feel unsafe and annoying.</li>
                  <li>Related Pain Points: User feel unsafe inserting personal information, Company high rate of fake personal information</li>
                  <li>Why Urgent: These feelings negatively affect the experience and completion rate</li>
                  <li>How it works: Information collection is merged with sign-up, users are informed ahead where prompts may appear, a non-disclosure claim is added for transparency, and a "skip for now" button gives users a sense of control.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Solution 4: Early Service Information */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">4. Early Service Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_03d9360c1c3b404ba4db11bda2232f5c~mv2.png/v1/fill/w_1070,h_1134,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Company%20Service%20and%20Strengths%20(2).png"
                  alt="Early Service Information"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_03d9360c1c3b404ba4db11bda2232f5c~mv2.png/v1/fill/w_1070,h_1134,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Company%20Service%20and%20Strengths%20(2).png")}
                />
              </div>
              <div>
                <ul className="list-disc list-inside space-y-2">
                  <li>Frustrations: Lack of clear service information</li>
                  <li>Related Pain Points: User lack of key information on the website, Company users are confused about the service offered</li>
                  <li>Why Urgent: Poor communication can impact business growth</li>
                  <li>How it works: A page highlighting services appears at the beginning of the key flow, triggered by the "Design Studio" button, one of the most clicked links in analytics.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Solution 5: Enhanced Navigation */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">5. Enhanced Navigation</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_7db24daf4ebe4ef4952e21f6809eacbf~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_7db24daf4ebe4ef4952e21f6809eacbf~mv2.png"
                  alt="Enhanced Navigation"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_7db24daf4ebe4ef4952e21f6809eacbf~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_7db24daf4ebe4ef4952e21f6809eacbf~mv2.png")}
                />
              </div>
              <div>
                <ul className="list-disc list-inside space-y-2">
                  <li>Frustrations: Users seeking case studies or services find them hard to locate</li>
                  <li>Related Pain Points: User lack of access to key information, Company low engagement time and unclear service offerings</li>
                  <li>Why Urgent: Failure to provide what users are looking for leads to lost conversions</li>
                  <li>How it works: Add fixed navigation links to highlight services and previous case studies</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Solution 6: "Saved" Notification */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">6. "Saved" Notification</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_88c52e98616947d1af1758eef6ae5575~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_88c52e98616947d1af1758eef6ae5575~mv2.png"
                  alt="Saved Notification"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_88c52e98616947d1af1758eef6ae5575~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_88c52e98616947d1af1758eef6ae5575~mv2.png")}
                />
              </div>
              <div>
                <ul className="list-disc list-inside space-y-2">
                  <li>Frustrations: Violation of Heuristic Principles. Visibility of System Status: When clicking save, users don't know whether it was successful.</li>
                  <li>Related Pain Points: User lack of trust in the company, Company low engagement time</li>
                  <li>Why Urgent: Usability is greatly impacted if not fixed. This is in the main CTA flow. Get a Quote. Uncertainty can lead to frustration and reduced trust.</li>
                  <li>How it works: A message pops up indicating whether the save action was successful.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Solution 7: Persistent Progress Indicator */}
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-4">7. Persistent Progress Indicator</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex justify-center">
                <img
                  src="https://static.wixstatic.com/media/cc7e8a_3ea4f55c96a3485f9046d622deacc78c~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_3ea4f55c96a3485f9046d622deacc78c~mv2.png"
                  alt="Persistent Progress Indicator"
                  className="max-w-full h-auto cursor-zoom-in"
                  onClick={() => toggleZoom("https://static.wixstatic.com/media/cc7e8a_3ea4f55c96a3485f9046d622deacc78c~mv2.png/v1/fill/w_1070,h_1132,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/cc7e8a_3ea4f55c96a3485f9046d622deacc78c~mv2.png")}
                />
              </div>
              <div>
                <ul className="list-disc list-inside space-y-2">
                  <li>Frustrations: Violation of Heuristic Principles. Visibility of System Status: Users are not notified when the task is completed.</li>
                  <li>Related Pain Points: User lack of trust in the company, Company low engagement time</li>
                  <li>Why Urgent: Task completion clarity affects confidence. If not fixed, users might get frustrated and lose trust in the company.</li>
                  <li>How it works: The progress bar sticks to the top and shows 100% when all steps are complete.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-8">
        <div className="container mx-auto px-6 sm:px-8 md:px-12">
          <h2 className="text-2xl font-bold mb-8 text-center">Impact of design solutions</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="p-6 border bg-white flex flex-col items-center text-center">
              <p className="text-4xl font-bold text-primary">5/5</p>
              <p className="mt-2">clear about company service</p>
            </div>
            <div className="p-6 border bg-white flex flex-col items-center text-center">
              <p className="text-4xl font-bold text-primary">40s</p>
              <p className="mt-2">increase in website engagement time</p>
            </div>
            <div className="p-6 border bg-white flex flex-col items-center text-center">
              <p className="text-4xl font-bold text-primary">4/5</p>
              <p className="mt-2">feel safe to leave personal info on website</p>
            </div>
          </div>
        </div>
      </section>

      {/* Case Study Navigation */}
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16 max-w-7xl py-12 border-t border-gray-200">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6">
          <Link
            to="/DesignSystem"
            className="flex items-center gap-2 text-lg text-primary hover:opacity-70 transition-opacity font-light"
          >
            ← Previous Case Study: Design System
          </Link>
          <Link
            to="/HSPPlanet"
            className="flex items-center gap-2 text-lg text-primary hover:opacity-70 transition-opacity font-light"
          >
            Next Case Study: HSP Planet →
          </Link>
        </div>
      </div>

    </Layout>
  );
};

export default ModelReno;